import React, { useState, useEffect } from 'react';
import WithdrawFunds from './WithdrawFunds';
const WithdrawFundsController = () => {
  const [amount, setAmount] = useState(null);
  const handleAmountValueChange = (values) => {
    setAmount(values.substring(2));
  };
  const [withdrawFundsData, setWithdrawFundsData] = useState({
    accountDetails:[{
          text: "Closing Balance",
          value: 277.81,  
        },
        {
          text: "Unsettled Credits",
          value: 0,  
        },{
          text: "Payin",
          value: 0,  
        },{
          text: "Collateral Utilised",
          value: 0,  
        }],
    withdrawableBalance: 277.81,
    bankDetais: [{
        id: 1,
        label: "HDFC"
    },{
        id: 2,
        label: "ICICI"
    }]
  });

  useEffect(() => {
    // Simulate fetching data from an API or some other source
    // const fetchData = async () => {
    //   try {
    //     // Replace this with your actual data fetching logic
    //     const response = await fetch('your_api_endpoint_here');
    //     const data = await response.json();

    //     // Assuming the data structure is an array and you want the first item
    //     if (Array.isArray(data) && data.length > 0) {
    //       setHoldingData(data[0]);
    //     }
    //   } catch (error) {
    //     console.error('Error fetching holding data:', error);
    //   }
    // };

    // fetchData();
  }, []); // Empty dependency array to fetch data only once on component mount

  return <WithdrawFunds data={withdrawFundsData} 
  
  handleAmountValueChange={handleAmountValueChange}
  />;
};

export default WithdrawFundsController;
